export default __webpack_public_path__ + "static/media/Rust_programming_language_black_logo.d1a18d42.svg";